import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Milestones for retailers who have installed the retailer Faire app on Shopify
 */
export const SHOPIFY_LEAD_ELIGIBLE_FOR_INCENTIVES =
  'SHOPIFY_LEAD_ELIGIBLE_FOR_INCENTIVES' as IUserMilestone.RetailerMilestone;
